export const network = {
  twitter: 'https://platform.twitter.com/widgets.js',
  tiktok: 'https://www.tiktok.com/embed.js',
  instagram: 'https://www.instagram.com/embed.js',
  telegram: 'https://telegram.org/js/telegram-widget.js',
  flourish: 'https://public.flourish.studio/resources/embed.js',
};
